import React, { useState } from 'react';
import dayjs from 'dayjs';

import {
  DeliveryContext,
  ThemeProvider,
  BotContext
} from '@sopranodesign/pulse-volt';
import { SubscriptionContext } from '@sopranodesign/pulse-subscribe';

import { useBotSettings } from '../hooks/index';

const noop = () => undefined;

const messages = [
  {
    content: {
      text: 'An example message from your chatbot'
    },
    direction: 'toClient',
    type: 'standard',
    sentAt: dayjs()
  },
  {
    content: {
      text: "An example message from your chatbot's user"
    },
    direction: 'toServer',
    type: 'standard',
    sentAt: dayjs()
  },
  {
    content: {
      text: 'An example quick reply message from your chatbot',
      responses: [{ label: 'One' }, { label: 'Two' }, { label: 'Three' }]
    },
    direction: 'toClient',
    type: 'quick-reply',
    sentAt: dayjs()
  }
];

const BotProvider = ({ children, ...props }) => {
  const {
    settings,
    name,
    bannerTitle,
    bannerSubtitle,
    buttons
  } = useBotSettings();
  const [showBurgerMenu, setShowBurgerMenu] = useState(false);

  return (
    <SubscriptionContext.Provider
      value={{ socket: { on: () => {}, off: () => {} }, connected: true }}>
      <DeliveryContext.Provider
        value={{
          sendMessage: () => null,
          resubscribe: () => null,
          channel: null,
          setChannel: null,
          api_url: null,
          hasChannel: true
        }}>
        <ThemeProvider
          value={{
            launcherEnabled: settings.launcher_logo_enabled,
            launcherLogo: settings.launcher_logo_url,
            ...settings.styles
          }}>
          <BotContext.Provider
            value={{
              messages,
              showName: settings.name_enabled,
              name,
              logo: settings.logo,
              showLogo: settings.logo_enabled,
              showlauncher: settings.launcher_logo_enabled,
              launcherLogoUrl: settings.launcher_logo_url,
              showDateTime: settings.timestamp_enabled,
              logoLink: settings.logo_link,
              showBanner: settings.banner_enabled,
              title: bannerTitle,
              subtitle: bannerSubtitle,
              initialShowCta: settings.call_to_action_enabled,
              showCta: settings.call_to_action_enabled,
              setShowCta: () => {},
              ctaText: 'This is what a call-to-action looks like',
              showAvatars: settings.avatars_enabled,
              humanAvatarUrl: settings.human_avatar_url,
              botAvatarUrl: settings.bot_avatar_url,
              showClose: true,
              showBurgerIcon: buttons && buttons.length > 0,
              showBurgerMenu,
              buttons,
              setShowBurgerMenu,
              showReset: settings.reset_enabled,
              showChangeLanguage: settings.change_subscriber_language_enabled,
              showExportTranscript: settings.export_transcript_enabled,
              showExportSubscriber: settings.export_subscriber_enabled,
              showDeleteSubscriber: settings.delete_subscriber_enabled,
              hasActiveSettings:
                settings.reset_enabled ||
                settings.change_subscriber_language_enabled ||
                settings.export_transcript_enabled ||
                settings.export_subscriber_enabled ||
                settings.delete_subscriber_enabled
                  ? true
                  : false,
              onWidgetShow: noop,
              onWidgetOpen: noop,
              onWidgetClose: noop,
              onCtaHide: noop,
              onIframeModalOpen: noop,
              onIframeModalClose: noop,
              onLightboxOpen: noop,
              onLightboxClose: noop,
              autofocusComposer: false,
              showPoweredByUbisend: settings.styles?.showPoweredByUbisend,
              footerImageUrl: settings.styles?.footerImageUrl,
              footerUrl: settings.styles?.footerUrl,
              ...props
            }}>
            {children}
          </BotContext.Provider>
        </ThemeProvider>
      </DeliveryContext.Provider>
    </SubscriptionContext.Provider>
  );
};

export default BotProvider;
